import React from 'react';
import 'styles/landing.css';
import { useLandingTheme } from './hooks/useLandingTheme';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import BottomCta from './components/BottomCta';
import Footer from './components/Footer';

const FamousClickerLanding: React.FC = () => {
  const isDark = useLandingTheme();

  return (
    <div
      className="font-geist min-h-screen"
      style={{ background: isDark ? '#0F172B' : '#F8FAFC' }}
    >
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <TestimonialsSection />
      <PricingSection />
      <BottomCta />
      <Footer />
    </div>
  );
};

export default FamousClickerLanding;
